{
  "expandButtonClose": "Show more",
  "expandButtonOpen": "Show less"
}
